import React from 'react';

import type { UserResponse } from '../types';

export const UserContext = React.createContext<{ user?: UserResponse }>({});
